module.exports = __webpack_public_path__ + "static/media/Scale.c8f31f5e.png";